import StarEffect from '../../three-components/StarEffect';
import React, { Component, useEffect, useRef } from 'react';
import { GUI } from 'three/examples/jsm/libs/dat.gui.module';
import * as THREE from 'three';

const createCube = function () {
    const geometry = new THREE.BoxGeometry(1, 1, 1);
    const material = new THREE.MeshBasicMaterial({ color: 0x00ff00 });
    const cube = new THREE.Mesh(geometry, material);
    window.cube = cube;
    cube.scale.set(.1, .1, .1);
    // cube.position.x=-5.2;
    // cube.position.y=-5.2;
    cube.position.set(-5, 0, 0)
    return cube
}

const createDatGui = function(obj, folderName){
    if (!window.DATGUI_DEFINED){
        var guiDiv = document.createElement('div');
        guiDiv.style.zIndex = 99;
        guiDiv.style.position = 'fixed';
        guiDiv.style.top = '0px';
        var bod = document.getElementsByTagName('body')[0];
        bod.appendChild(guiDiv);

        const gui = new GUI({autoPlace:false});
        window.gui = gui;
        // gui.close();
        // var cont = document.getElementById('datgui');
        guiDiv.appendChild(gui.domElement);
        window.DATGUI_DEFINED = true;

    }
    const folder = gui.addFolder(folderName);

    // const folder1 = gui.addFolder('folder1');

    // folder1.add(obj.material.uniforms.lacunarity, 'value').name('lacunarity x').min(0).max(10).step(0.001);
    // folder1.add(obj.material.uniforms.gain, 'value').name('gain y').min(0).max(10).step(0.001);
    // folder1.add(obj.material.uniforms.magnitude, 'value').name('magnitude z').min(0).max(10).step(0.001);

    // folder.add(obj.rotation, 'x').name('rotation x').min(-7).max(7).step(0.001);
    // folder.add(obj.rotation, 'y').name('rotation y').min(-7).max(7).step(0.001);
    // folder.add(obj.rotation, 'z').name('rotation z').min(-7).max(7).step(0.001);

    // folder.add(obj.scale, 'x').name('scale x').min(-10).max(10).step(0.001);
    // folder.add(obj.scale, 'y').name('scale y').min(-10).max(10).step(0.001);
    // folder.add(obj.scale, 'z').name('scale z').min(-10).max(10).step(0.001);

    folder.add(obj.position, 'x').name('position x').min(-10).max(10).step(0.001);
    folder.add(obj.position, 'y').name('position y').min(-10).max(10).step(0.001);
    folder.add(obj.position, 'z').name('position z').min(-10).max(10).step(0.001);
}

function getDistance3D(x1,y1,z1,x2,y2,z2){
    return Math.sqrt( (x2-x1)**2 +(y2-y1)**2 +(z2-z1)**2 );
}

function getMidPoint3D(x1,y1,z1,x2,y2,z2){
    return [x1+(x2-x1)/2,y1+(y2-y1)/2,z1+(z2-z1)/2]
}

function getGeneralLinePoints(n,startX,endX,startY,endY,startZ,endZ, curvature = [0,0,0], jitter = [0,0,0]){
    var incX = (endX - startX) / n;
    var incY = (endY - startY) / n;
    var incZ = (endZ - startZ) / n;

    var counter = 0
    var ret = [];

    var midPoint = getMidPoint3D(startX,startY,startZ,endX,endY,endZ);
    var distanceToMid, curvatureOffsets, jitters;

    //debugger;

    while (counter<n){
        var x = startX + incX * counter;
        var y = startY + incY * counter;
        var z = startZ + incZ * counter;

        distanceToMid = getDistance3D(x,y,z,midPoint[0],midPoint[1],midPoint[2]);
        curvatureOffsets = [curvature[0] * distanceToMid**2, curvature[1] * distanceToMid**2, curvature[2] * distanceToMid**2]
        jitters = [Math.random()-.5, Math.random()-.5, Math.random()-.5];

        ret.push([
            x + curvatureOffsets[0] + (jitter[0] * jitters[0]),
            y + curvatureOffsets[1] + (jitter[1] * jitters[1]),
            z + curvatureOffsets[2] + (jitter[2] * jitters[2]),
        ])

        counter+=1;
    }
    return ret;
}

function ptsInTriangle(n,x1,y1,z1,x2,y2,z2,x3,y3,z3) {
    var ret = [];
    for(var i =0; i<n; i++){
        let p = Math.random()
        let q = Math.random()
        if (p + q > 1) {
            p = 1 - p
            q = 1 - q
        }
        // A + AB * p + BC * q
        let x = x1 + (x2 - x1) * p + (x3 - x1) * q;
        let y = y1 + (y2 - y1) * p + (y3 - y1) * q;
        let z = z1 + (z2 - z1) * p + (z3 - z1) * q;
        ret.push([x,y,z])
    }
    return ret;
}


function getCurvedLinePointsConstZ(n, start, end, height, z = 5, curvature = .2, jitter = .3) {
    //constant Z axis 5 or -5
    var mid = getMidPoint(start, end);
    var incX = (Math.max(end, start) - Math.min(end, start)) / n;

    var x = Math.min(start, end), y = height, counter = 0;

    var fullDistance = mid - start;

    ret = [];
    while (counter < n) {
        var proportionToMid = (x - mid) / fullDistance;
        proportionToMid *= -1 * proportionToMid * curvature;
        var randJitter = Math.random() * jitter;
        ret.push([x, height + proportionToMid + randJitter, z]);

        counter += 1; x += incX;
    }
    return ret;

}

function getCurvedLinePointsConstX(n, constantAxis, constantAxisValue, startX, endX, startY, endY, curvature = .3, jitterX = 0, jitterY = 0) {
    //assumed to be a horizontal line
    var ret = [];
    //make the inc always positive

    var incX = (Math.max(endX, startX) - Math.min(endX, startX)) / n;
    var incY = (Math.max(endY, startY) - Math.min(endY, startY)) / n;
    // for (let i=startX ,j=startY; Math.abs(i) < Math.abs(endX) && Math.abs(j)<Math.abs(endY); i>0? i+= incX:i-=incX, j>0?j+=incY:j-=incY) {

    var midPoint = startY + (endY - startY) / 2;

    let i = Math.min(startX, endX), j = Math.min(startY, endY), counter = 0;

    var distanceToMid = j - midPoint;
    while (counter < n) {
        var proportionToMid = (j - midPoint) / distanceToMid;
        proportionToMid = proportionToMid * proportionToMid * curvature;
        proportionToMid = proportionToMid * -1;
        var jitterFinalX = jitterX * Math.random() - .5 * jitterX;
        var jitterFinalY = jitterY * Math.random() - .5 * jitterY;
        if (constantAxis == 0)
            ret.push([constantAxisValue, i + proportionToMid + jitterFinalX, j + jitterFinalY]);
        if (constantAxis == 1)
            ret.push([i + j + proportionToMiditterFinalX, constantAxisValue, j + jitterFinalY]);
        if (constantAxis == 2)
            ret.push([j + proportionToMid + jitterFinalX, i + jitterFinalY, constantAxisValue]);
        i += incX; j += incY;
        // i>0? i+= incX:i-=incX; j>0?j+=incY:j-=incY;
        counter += 1;

    }
    window.ret = ret;

    return ret;
}



function getParallelLinePoints(nLines, nLights, constantAxis, constantAxisValue, incX, incY, startX, endX, startY, endY, jitterX=.1, jitterY=.1){
    var ret = [];
    for (let i = 0; i < nLines; i++) {
        // debugger;
        const line = getLinePoints2(nLights,constantAxis, constantAxisValue, startX+i*incX, endX+i*incX, startY+i*incY, endY+i*incY, jitterX, jitterY);
        ret.push(line);
    }
    return ret;
}



function getLinePoints(n, constantAxis, constantAxisValue, startX, endX, startY, endY, jitterX = 0, jitterY = .1) {
    var ret = [];
    //make the inc always positive

    var incX = (Math.max(endX, startX) - Math.min(endX, startX)) / n;
    var incY = (Math.max(endY, startY) - Math.min(endY, startY)) / n;
    // debugger;
    // for (let i=startX ,j=startY; Math.abs(i) < Math.abs(endX) && Math.abs(j)<Math.abs(endY); i>0? i+= incX:i-=incX, j>0?j+=incY:j-=incY) {

    let i = Math.min(startX, endX), j = Math.min(startY, endY), counter = 0;

    while (counter < n) {
        var jitterFinalX = jitterX * Math.random() - .5 * jitterX;
        var jitterFinalY = jitterY * Math.random() - .5 * jitterY;
        if (constantAxis == 0)
            ret.push([constantAxisValue, i + jitterFinalX, j + jitterFinalY]);
        if (constantAxis == 1)
            ret.push([i + jitterFinalX, constantAxisValue, j + jitterFinalY]);
        if (constantAxis == 2)
            ret.push([i + jitterFinalX, j + jitterFinalY, constantAxisValue]);
        i += incX; j += incY;
        // i>0? i+= incX:i-=incX; j>0?j+=incY:j-=incY;
        counter += 1;

    }
    window.ret = ret;

    return ret;
}

function getLinePoints2(n, constantAxis, constantAxisValue, startX, endX, startY, endY, jitterX = 0, jitterY = .1) {
    var ret = [];
    //make the inc always positive

    var incX = (endX  - startX) / n;
    var incY = (endY  - startY) / n;
    // debugger;
    // for (let i=startX ,j=startY; Math.abs(i) < Math.abs(endX) && Math.abs(j)<Math.abs(endY); i>0? i+= incX:i-=incX, j>0?j+=incY:j-=incY) {

    let i = startX, j = startY, counter = 0;

    while (counter < n) {
        var jitterFinalX = jitterX * Math.random() - .5 * jitterX;
        var jitterFinalY = jitterY * Math.random() - .5 * jitterY;
        if (constantAxis == 0)
            ret.push([constantAxisValue, i + jitterFinalX, j + jitterFinalY]);
        if (constantAxis == 1)
            ret.push([i + jitterFinalX, constantAxisValue, j + jitterFinalY]);
        if (constantAxis == 2)
            ret.push([i + jitterFinalX, j + jitterFinalY, constantAxisValue]);
        i += incX; j += incY;
        // i>0? i+= incX:i-=incX; j>0?j+=incY:j-=incY;
        counter += 1;

    }
    window.ret = ret;

    return ret;
}

function getMidPoint(a, b) {
    var small, big;
    small = Math.min(a, b);
    big = Math.max(a, b);
    return small + (big - small) / 2;
}

function getCurvedLinePoints2(n, start, end, height, z = 5, curvature = .2, jitter = .3) {
    //constant Z axis 5 or -5
    var mid = getMidPoint(start, end);
    var incX = (Math.max(end, start) - Math.min(end, start)) / n;

    var x = Math.min(start, end), y = height, counter = 0;

    var fullDistance = mid - start;

    ret = [];
    while (counter < n) {
        var proportionToMid = (x - mid) / fullDistance;
        proportionToMid *= -1 * proportionToMid * curvature;
        var randJitter = Math.random() * jitter;
        ret.push([x, height + proportionToMid + randJitter, z]);

        counter += 1; x += incX;
    }
    return ret;

}

function getCurvedLinePoints(n, constantAxis, constantAxisValue, startX, endX, startY, endY, curvature = .3, jitterX = 0, jitterY = 0) {
    //assumed to be a horizontal line
    var ret = [];
    //make the inc always positive

    var incX = (Math.max(endX, startX) - Math.min(endX, startX)) / n;
    var incY = (Math.max(endY, startY) - Math.min(endY, startY)) / n;
    // for (let i=startX ,j=startY; Math.abs(i) < Math.abs(endX) && Math.abs(j)<Math.abs(endY); i>0? i+= incX:i-=incX, j>0?j+=incY:j-=incY) {

    var midPoint = startY + (endY - startY) / 2;

    let i = Math.min(startX, endX), j = Math.min(startY, endY), counter = 0;

    var distanceToMid = j - midPoint;
    while (counter < n) {
        var proportionToMid = (j - midPoint) / distanceToMid;
        proportionToMid = proportionToMid * proportionToMid * curvature;
        proportionToMid = proportionToMid * -1;
        var jitterFinalX = jitterX * Math.random() - .5 * jitterX;
        var jitterFinalY = jitterY * Math.random() - .5 * jitterY;
        if (constantAxis == 0)
            ret.push([constantAxisValue, i + proportionToMid + jitterFinalX, j + jitterFinalY]);
        if (constantAxis == 1)
            ret.push([i + j + proportionToMiditterFinalX, constantAxisValue, j + jitterFinalY]);
        if (constantAxis == 2)
            ret.push([j + proportionToMid + jitterFinalX, i + jitterFinalY, constantAxisValue]);
        i += incX; j += incY;
        // i>0? i+= incX:i-=incX; j>0?j+=incY:j-=incY;
        counter += 1;

    }
    window.ret = ret;

    return ret;
}


const COUNT_MULT = 1;
const MIN_MULT = 2;
const MAX_MULT = 2;


export function renderStarFlashes (id,threeJSWorldContext){
    // debugger;
    // const { id, threeJSWorldContext } = this.props
    if (id === '617b14d07029464b67da1fb3') {

        // if (! window.x){
        //     var cube = createCube();
        //     threeJSWorldContext.scene.add(cube);
        //     createDatGui(cube,'cube');
        //     window.x = true;
        // }

        //entrance

        // left group order:
        // left lower box, box on top of it.
        //side parallels
        const parallelLinesPoints = getParallelLinePoints(5,30,0,-5,.1,0,-1,-1,4.8,2.4,.05,.05 );

        const patchLinePts = getGeneralLinePoints(COUNT_MULT * 15, -5,-5,-0.646,-1.05,-0.867,-1.9,[0,0,0],[0,0,.05])
        const patchLine = (
            <StarEffect
                scaleRange={[MIN_MULT * .05, .09 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={patchLinePts}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )
        
        const parallelLines = parallelLinesPoints.map((pts)=>(
            <StarEffect
            scaleRange={[MIN_MULT * .04, .07 * MAX_MULT]}
            // positionRange={rightGroupA}
            determinedPositions={pts}
            scene={threeJSWorldContext.scene}
            addToRenderLoop={threeJSWorldContext.addToRenderLoop}
            removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
            // starCount={COUNT_MULT*30}
            randomizeColor={false}
        />
        ))

        const parallelLinesPoints2 = getParallelLinePoints(5,30,0,-5,.09,0,-.56 ,-.56 ,1.1,4.7,.05,.05 );
        
        const parallelLines2 = parallelLinesPoints2.map((pts)=>(
            <StarEffect
            scaleRange={[MIN_MULT * .04, .07 * MAX_MULT]}
            // positionRange={rightGroupA}
            determinedPositions={pts}
            scene={threeJSWorldContext.scene}
            addToRenderLoop={threeJSWorldContext.addToRenderLoop}
            removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
            // starCount={COUNT_MULT*30}
            randomizeColor={false}
        />
        ))

        // const parallelLinesPoints3 = getParallelLinePoints(3,30,0,-5,.13,-.1,-.75 ,0.14 ,3.6,1.338,.1,.1 );
        
        // const parallelLines3 = parallelLinesPoints3.map((pts)=>(
        //     <StarEffect
        //     scaleRange={[MIN_MULT * .05, .09 * MAX_MULT]}
        //     // positionRange={rightGroupA}
        //     determinedPositions={pts}
        //     scene={threeJSWorldContext.scene}
        //     addToRenderLoop={threeJSWorldContext.addToRenderLoop}
        //     removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
        //     // starCount={COUNT_MULT*30}
        //     randomizeColor={false}
        // />
        // ))

        // const leftGroupSmallPatch = {
        //     x: [-5, -5],
        //     y: [-.4, 0],
        //     z: [2.88, 3.7],
        // }
        // const leftPatch = (
        //     <StarEffect
        //         scaleRange={[MIN_MULT*.05,MAX_MULT*.09]}
        //         positionRange={leftGroupSmallPatch}
        //         scene={threeJSWorldContext.scene}
        //         addToRenderLoop={threeJSWorldContext.addToRenderLoop}
        //         removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
        //         starCount={ 20}
        //         randomizeColor={false}
        //     />
        // )
        
        
        //right group: upper box, lower box, patch
        const parallelLinesPointsRight = getParallelLinePoints(5,30,0,-5,.1,0,-.6 ,-.6 ,-.65,-3.7,.05,.05 );
        const parallelLinesRight = parallelLinesPointsRight.map((pts)=>(
            <StarEffect
            scaleRange={[MIN_MULT * .04, .08 * MAX_MULT]}
            // positionRange={rightGroupA}
            determinedPositions={pts}
            scene={threeJSWorldContext.scene}
            addToRenderLoop={threeJSWorldContext.addToRenderLoop}
            removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
            // starCount={COUNT_MULT*30}
            randomizeColor={false}
        />
        ))

        const parallelLinesPointsRight2 = getParallelLinePoints(5,20,0,-5,.1,0,-1.05 ,-1.05 ,-1.97,-3.7,.05,.05 );
        const parallelLinesRight2 = parallelLinesPointsRight2.map((pts)=>(
            <StarEffect
            scaleRange={[MIN_MULT * .04, .08 * MAX_MULT]}
            // positionRange={rightGroupA}
            determinedPositions={pts}
            scene={threeJSWorldContext.scene}
            addToRenderLoop={threeJSWorldContext.addToRenderLoop}
            removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
            // starCount={COUNT_MULT*30}
            randomizeColor={false}
        />
        ))

        const rightGroupTrianglePts = ptsInTriangle(25,-5,-.645,-.867,-5,-.646,-1.9,-5,-1,-1.9);
        const rightGroupTriangle = (
            <StarEffect
                scaleRange={[MIN_MULT * .04, .08 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={rightGroupTrianglePts}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*100}
                randomizeColor={false}
            />
        )

        const leftGroupTrianglePts = ptsInTriangle(25,-5,-.644,2.35,-5,-1,2.35,-5,-.55,1.118);
        const leftGroupTriangle = (
            <StarEffect
                scaleRange={[MIN_MULT * .04, .08 * MAX_MULT]}
                // positionRange={leftGroupA}
                determinedPositions={leftGroupTrianglePts}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*100}
                randomizeColor={false}
            />
        )

        const rightGroupB = {
            x: [-5, -5],
            y: [-.6, 0],
            z: [-3.9, -2.88],
        }
        const AB = (
            <StarEffect
                scaleRange={[MIN_MULT*.05,MAX_MULT*.09]}
                positionRange={rightGroupB}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                starCount={ 40}
                randomizeColor={false}
            />
        )
        const rightGroupB2 = {
            x: [-5, -5],
            y: [-.42, 0],
            z: [-2.88, -2.4],
        }
        const AB2 = (
            <StarEffect
                scaleRange={[MIN_MULT*.05,MAX_MULT*.09]}
                positionRange={rightGroupB2}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                starCount={ 25}
                randomizeColor={false}
            />
        )

        const leftGroupA = {
            x: [-5, -5],
            y: [0, .67,],
            z: [1.5, 7],
        }
        const BA = (
            <StarEffect
                scaleRange={[.2,.3]}
                positionRange={leftGroupA}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                starCount={ 100}
                randomizeColor={false}
            />
        )

        const leftGroupB = {
            x: [-5, -5],
            y: [0, -0.78],
            z: [3.7, 7.7],
        }
        const BB = (
            <StarEffect
                scaleRange={[.2,.3]}
                positionRange={leftGroupB}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                starCount={ 100}
                randomizeColor={false}
            />
        )

        return (
            <>
            {parallelLines}
            {parallelLines2}
            {patchLine}
            {parallelLinesRight}
        {parallelLinesRight2}

        {rightGroupTriangle}
        {leftGroupTriangle}


            {/* {AB} */}
            {/* {AB2} */}
        {/* {leftPatch} */}

                {/* {AA}
                {AB}
                {BA}
                {BB} */}
            </>
        )
    }
    if (id === '614c8c355d0a6b36fe5ab366') {
        //projection/

        // if (! window.x){
        //     var cube = createCube();
        //     threeJSWorldContext.scene.add(cube);
        //     createDatGui(cube,'cube');
        //     window.x = true;
        // }


        //counting lines from the left
        const leftLinePoints = getGeneralLinePoints(COUNT_MULT * 30, -5,-5,0.17,-.9,0+.1,.4+.1,[0,0,-.3],[0,0,.05])
        const leftLine = (
            <StarEffect
                scaleRange={[MIN_MULT * .05, .09 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={leftLinePoints}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )
        const leftLinePoints2 = getGeneralLinePoints(COUNT_MULT * 30, -5,-5,0.17,-1,0+.05,.236+.05,[0,0,-.1],[0,0,.05])
        const leftLine2 = (
            <StarEffect
                scaleRange={[MIN_MULT * .05, .09 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={leftLinePoints2}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )
        const leftLinePoints3 = getGeneralLinePoints(COUNT_MULT * 30, -5,-5,0.17,-1,0+.03,0+.03,[0,0,-.1],[0,0,.05])
        const leftLine3 = (
            <StarEffect
                scaleRange={[MIN_MULT * .05, .09 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={leftLinePoints3}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )
        const leftLinePoints4 = getGeneralLinePoints(COUNT_MULT * 30, -5,-5,0.17,-1,0-.06,-.205-.06,[0,0,.1],[0,0,.05])
        const leftLine4 = (
            <StarEffect
                scaleRange={[MIN_MULT * .05, .09 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={leftLinePoints4}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )
        const leftLinePoints5 = getGeneralLinePoints(COUNT_MULT * 30, -5,-5,0.17,-.95,0-.05,-.426-.05,[0,0,.1],[0,0,.05])
        const leftLine5 = (
            <StarEffect
                scaleRange={[MIN_MULT * .05, .09 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={leftLinePoints5}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )

        const heater1 = getGeneralLinePoints(COUNT_MULT * 30, -2.25,-2.25,-.55,-1.6,5,5,[0,0,0],[.1,0,0])
        const heaterLeft = (
            <StarEffect
                scaleRange={[MIN_MULT * .05, .09 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={heater1}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )
        const heater2 = getGeneralLinePoints(COUNT_MULT * 30, -2.27,-4.175,-.55,-.55,5,5,[0,0,.1],[0,.1,.0])
        const heaterTop = (
            <StarEffect
                scaleRange={[MIN_MULT * .08, .17 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={heater2}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )
        const heater3 = getGeneralLinePoints(COUNT_MULT * 18, -4.23,-4.23,-.58,-1.6,5,5,[.1,0,0],[0,0,.05])
        const heaterRight = (
            <StarEffect
                scaleRange={[MIN_MULT * .08, .17 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={heater3}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )


        const aroundTreeLineSegmentsPts1 = getGeneralLinePoints(COUNT_MULT * 12, -5,-5,-.867,-.5,2.05,2.05,[0,0,0],[.1,0,0])
        const aroundTreeLineSegments1 = (
            <StarEffect
                scaleRange={[MIN_MULT * .05, .09 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={aroundTreeLineSegmentsPts1}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )
        const aroundTreeLineSegmentsPts2 = getGeneralLinePoints(COUNT_MULT * 10, -5,-5,-.5,-.5,2.1,1.9,[0,0,0],[0,.05,0])
        const aroundTreeLineSegments2 = (
            <StarEffect
                scaleRange={[MIN_MULT * .05, .09 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={aroundTreeLineSegmentsPts2}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )
        const aroundTreeLineSegmentsPts3 = getGeneralLinePoints(COUNT_MULT * 17, -5,-5,-.5,-.5,1.55,.55,[0,0,0],[0,0.05,0])
        const aroundTreeLineSegments3 = (
            <StarEffect
                scaleRange={[MIN_MULT * .05, .09 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={aroundTreeLineSegmentsPts3}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )
        const aroundTreeLineSegmentsPts4 = getGeneralLinePoints(COUNT_MULT * 17, -5,-5,-.5,-.1,.55,.55,[0,0,0],[0,0,.05])
        const aroundTreeLineSegments4 = (
            <StarEffect
                scaleRange={[MIN_MULT * .05, .09 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={aroundTreeLineSegmentsPts4}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )

        //hanging line right
        const aroundTreeLineSegmentsPts5 = getGeneralLinePoints(COUNT_MULT * 30, -5,-5,-.1-.1,.8-.1,-.55+.05,-.01+.05,[0,.5,0],[0,0,.05])
        const aroundTreeLineSegments5 = (
            <StarEffect
                scaleRange={[MIN_MULT * .05, .09 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={aroundTreeLineSegmentsPts5}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )
        //hanging line left
        const aroundTreeLineSegmentsPts6 = getGeneralLinePoints(COUNT_MULT * 30, -5,-5,-.1-.1,.8-.1,.55-.05,-.01-.05,[0,.5,0],[0,0,.05])
        const aroundTreeLineSegments6 = (
            <StarEffect
                scaleRange={[MIN_MULT * .05, .09 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={aroundTreeLineSegmentsPts6}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )

        const aroundTreeLineSegmentsPts7 = getGeneralLinePoints(COUNT_MULT * 14, -5,-5,-.1,-.5,-.55,-.55,[0,0,0],[0,0,.05])
        const aroundTreeLineSegments7 = (
            <StarEffect
                scaleRange={[MIN_MULT * .05, .09 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={aroundTreeLineSegmentsPts7}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )
        const aroundTreeLineSegmentsPts8 = getGeneralLinePoints(COUNT_MULT * 40, -5,-5,-.5,-.5,-.55,-2.1,[0,0,0],[0,.05,0])
        const aroundTreeLineSegments8 = (
            <StarEffect
                scaleRange={[MIN_MULT * .05, .09 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={aroundTreeLineSegmentsPts8}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )
        const aroundTreeLineSegmentsPts9 = getGeneralLinePoints(COUNT_MULT * 10, -5,-5,-.49,-.74,-2.08,-2.08,[0,0,0],[0,0,.05])
        const aroundTreeLineSegments9 = (
            <StarEffect
                scaleRange={[MIN_MULT * .05, .09 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={aroundTreeLineSegmentsPts9}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )

        return (
            <>
                {/* {leftLine}
                {leftLine2}
                {leftLine3}
                {leftLine4}
                {leftLine5}
                 */}
                {/* {heaterLeft}
                {heaterTop}
                {heaterRight}

                {aroundTreeLineSegments1}
                {aroundTreeLineSegments2}
                {aroundTreeLineSegments3}
                {aroundTreeLineSegments4}
                {aroundTreeLineSegments5}
                {aroundTreeLineSegments6}
                {aroundTreeLineSegments7}
                {aroundTreeLineSegments8}
                {aroundTreeLineSegments9} */}

            </>
        )
    }
    if (id === '61773f0a64cca322c1f89d54') {
        //projection-2

        // if (! window.x){
        //     var cube = createCube();
        //     threeJSWorldContext.scene.add(cube);
        //     createDatGui(cube,'cube');
        //     window.x = true;
        // }


        //counting lines from the left
        const leftLinePoints = getGeneralLinePoints(COUNT_MULT * 30, -5,-5,.6,-3.5,0+.3,1.5+.3,[0,0,-.05],[0,0,.1])
        const leftLine = (
            <StarEffect
                scaleRange={[MIN_MULT * .13, .18 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={leftLinePoints}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )
        const leftLinePoints2 = getGeneralLinePoints(COUNT_MULT * 30, -5,-5,.6,-3.5,0+.2,.8+.2,[0,0,-.05],[0,0,.1])
        const leftLine2 = (
            <StarEffect
                scaleRange={[MIN_MULT * .13, .18 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={leftLinePoints2}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )
        const leftLinePoints3 = getGeneralLinePoints(COUNT_MULT * 30, -5,-5,.6,-3.5,0 ,0 ,[0,0,0],[0,0,.15])
        const leftLine3 = (
            <StarEffect
                scaleRange={[MIN_MULT * .13, .18 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={leftLinePoints3}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )
        const leftLinePoints4 = getGeneralLinePoints(COUNT_MULT * 30, -5,-5,.6,-3.5,0-.2,-.867-.2,[0,0,.05],[0,0,.1])
        const leftLine4 = (
            <StarEffect
                scaleRange={[MIN_MULT * .13, .18 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={leftLinePoints4}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )
        const leftLinePoints5 = getGeneralLinePoints(COUNT_MULT * 30, -5,-5,.6,-3.5,0-.25,-1.529-.25,[0,0,.05],[0,0,.15])
        const leftLine5 = (
            <StarEffect
                scaleRange={[MIN_MULT * .13, .18 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={leftLinePoints5}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )

        const heater1 = getGeneralLinePoints(COUNT_MULT * 30, 5.6,3.75,-.55,-.55,5,5,[0,0,0],[0,.1,.0])
        const heaterTop = (
            <StarEffect
                scaleRange={[MIN_MULT * .08, .17 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={heater1}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )

        const heater2 = getGeneralLinePoints(COUNT_MULT * 18, 3.65,3.65,-.58,-1.6,5,5,[0,0,0],[.1,0,0])
        const heaterRight = (
            <StarEffect
                scaleRange={[MIN_MULT * .08, .17 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={heater2}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )


        const aroundTreeLineSegmentsPts1 = getGeneralLinePoints(COUNT_MULT * 20, -5,-5,-2.411,-1.3,5.53,5.53,[0,0,0],[0,0,.1])
        const aroundTreeLineSegments1 = (
            <StarEffect
                scaleRange={[MIN_MULT * .08, .17 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={aroundTreeLineSegmentsPts1}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )
        const aroundTreeLineSegmentsPts2 = getGeneralLinePoints(COUNT_MULT * 50, -5,-5,-1.3,-1.3,5.53,1.45,[0,0,0],[0,.1,0])
        const aroundTreeLineSegments2 = (
            <StarEffect
                scaleRange={[MIN_MULT * .08, .17 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={aroundTreeLineSegmentsPts2}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )
        const aroundTreeLineSegmentsPts3 = getGeneralLinePoints(COUNT_MULT * 17, -5,-5,-1.3,-.426,1.45,1.45,[0,0,0],[0,0,.1])
        const aroundTreeLineSegments3 = (
            <StarEffect
                scaleRange={[MIN_MULT * .08, .17 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={aroundTreeLineSegmentsPts3}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )
        
        //hanging line right
        const aroundTreeLineSegmentsPts4 = getGeneralLinePoints(COUNT_MULT * 30, -5,-5,2,-.205,0+.3,-1.45+.3,[0,0,-.2],[0,0,.1])
        const aroundTreeLineSegments4 = (
            <StarEffect
                scaleRange={[MIN_MULT * .08, .17 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={aroundTreeLineSegmentsPts4}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
                />
            )
        //hanging line left
        const aroundTreeLineSegmentsPts5 = getGeneralLinePoints(COUNT_MULT * 30, -5,-5,2-.1,-.205-.1,0-.35,1.45-.35,[0,0,.25],[0,0,.1])
        const aroundTreeLineSegments5 = (
            <StarEffect
                scaleRange={[MIN_MULT * .08, .17 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={aroundTreeLineSegmentsPts5}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
                />
            )

            const aroundTreeLineSegmentsPts6 = getGeneralLinePoints(COUNT_MULT * 17, -5,-5,-.2,-1.3,-1.45,-1.45,[0,0,0],[0,0,.1])
            const aroundTreeLineSegments6 = (
                <StarEffect
                    scaleRange={[MIN_MULT * .08, .17 * MAX_MULT]}
                    // positionRange={rightGroupA}
                    determinedPositions={aroundTreeLineSegmentsPts6}
                    scene={threeJSWorldContext.scene}
                    addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                    removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                    // starCount={COUNT_MULT*30}
                    randomizeColor={false}
                />
            )

        const aroundTreeLineSegmentsPts7 = getGeneralLinePoints(COUNT_MULT * 40, -5,-5,-1.3,-1.3,-1.529,-5.55,[0,0,0],[0,.1,0])
        const aroundTreeLineSegments7 = (
            <StarEffect
                scaleRange={[MIN_MULT * .08, .17 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={aroundTreeLineSegmentsPts7}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )
        const aroundTreeLineSegmentsPts8 = getGeneralLinePoints(COUNT_MULT * 20, -5,-5,-1.3,-2.41,-5.48,-5.48,[0,0,0],[0,0,.1])
        const aroundTreeLineSegments8 = (
            <StarEffect
                scaleRange={[MIN_MULT * .08, .17 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={aroundTreeLineSegmentsPts8}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )
        return (
            <>
                {/* {leftLine}
                {leftLine2}
                {leftLine3}
                {leftLine4}
                {leftLine5} */}
                
                {/* {heaterTop}
                {heaterRight}

                {aroundTreeLineSegments1}
                {aroundTreeLineSegments2}
                {aroundTreeLineSegments3}
                {aroundTreeLineSegments4}
                {aroundTreeLineSegments5}
                {aroundTreeLineSegments6}
                {aroundTreeLineSegments7}
                {aroundTreeLineSegments8} */}

            </>
        )
    }
    if (id === '614b3e16d7bb008cbec58cb6') {
        //https://gitlab.com/ObsessVR/360Experiences/development-tasks/-/issues/3642

        //images in  the first post first, then images in the second post from Xue
        
        //dining
        //first image in the ticket
        const leftLinePoints = getLinePoints(COUNT_MULT * 30, 0, 5, -1.6, 2, -2.7, -2.7)
        const leftLine = (
            <StarEffect
                scaleRange={[MIN_MULT * .1, .15 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={leftLinePoints}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )
        
        //first image in the ticket
        const rightLinePoints = getLinePoints(COUNT_MULT * 30, 0, 5, 3.1, -1.55, 3.73, 3.15)
        const rightLine = (
            <StarEffect
                scaleRange={[MIN_MULT * .1, .15 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={rightLinePoints}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )

        // second image in the ticket
        const leftWindowLeftLinePoints = getLinePoints(COUNT_MULT * 30, 0, -5, 1.466, -.1, -2.19, -2.19,0,.05)
        const leftWindowLeftLine = (
            <StarEffect
                scaleRange={[MIN_MULT * .08, .12 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={leftWindowLeftLinePoints}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )
        
        //second image in the ticket
        const leftWindowRightLinePoints = getLinePoints(COUNT_MULT * 30, 0, -5, -1, 2.2, -3.35, -3.35,0,.05)
        const leftWindowRightLine = (
            <StarEffect
                scaleRange={[MIN_MULT * .1, .15 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={leftWindowRightLinePoints}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )
        // second image in the ticket
        const rightWindowLeftLinePoints = getLinePoints(COUNT_MULT * 60, 2,-5,  -2.4, -2.4,-1.528, 3.3,0.1,0)
        const rightWindowLeftLine = (
            <StarEffect
                scaleRange={[MIN_MULT * .1, .15 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={rightWindowLeftLinePoints}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )
        
        //second image in the ticket
        const rightWindowRightLinePoints = getLinePoints(COUNT_MULT * 60, 2,-5,  1.5, 1.5,-1.08, 3.3,.1,0)
        const rightWindowRightLine = (
            <StarEffect
                scaleRange={[MIN_MULT * .1, .15 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={rightWindowRightLinePoints}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
        )
        const aboveHeaterPoints = getLinePoints(COUNT_MULT * 30, 2, -5, -6.6, -3.7, -.23,-.23,0,.1)
        const aboveHeaterPointsLine = (
            <StarEffect
                scaleRange={[MIN_MULT * .1, .15 * MAX_MULT]}
                // positionRange={rightGroupA}
                determinedPositions={aboveHeaterPoints}
                scene={threeJSWorldContext.scene}
                addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                // starCount={COUNT_MULT*30}
                randomizeColor={false}
            />
            )
            // third image in the ticket

            //actually its right line
            //first two are for y
            const leftHangingLinePoints = getLinePoints2(COUNT_MULT * 30, 0,-5,.85, 0.06,.03, -.64,.05,0)
            const leftHangingLine = (
                <StarEffect
                    scaleRange={[MIN_MULT * .04, .085 * MAX_MULT]}
                    // positionRange={rightGroupA}
                    determinedPositions={leftHangingLinePoints}
                    scene={threeJSWorldContext.scene}
                    addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                    removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                    // starCount={COUNT_MULT*30}
                    randomizeColor={false}
                />
            )
            //actually it's left line
            //third image in the ticket
            const rightHangingLinePoints = getLinePoints2(COUNT_MULT * 30, 0,-5,  .85, 0,.03, .89,.05,0)
            const rightHangingLine = (
                <StarEffect
                    scaleRange={[MIN_MULT * .04, .085 * MAX_MULT]}
                    // positionRange={rightGroupA}
                    determinedPositions={rightHangingLinePoints}
                    scene={threeJSWorldContext.scene}
                    addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                    removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                    // starCount={COUNT_MULT*30}
                    randomizeColor={false}
                />
            )

            //left window top line
            const curvedLinePoints = getLinePoints2(COUNT_MULT * 25, 0, -5, 1.55, 2.22, -2.3, -3.29, 0.05, 0)
            const curvedLine = (
                <StarEffect
                    scaleRange={[MIN_MULT * .06, .1 * MAX_MULT]}
                    // positionRange={rightGroupA}
                    determinedPositions={curvedLinePoints}
                    scene={threeJSWorldContext.scene}
                    addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                    removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                    // starCount={COUNT_MULT*100}
                    randomizeColor={false}
                />
            )

            //right window top line
            const curvedLinePoints2 = getLinePoints2(COUNT_MULT * 35, 2, -5, -2.41, 1.5, 3.4, 3.4, 0.1, 0)
            const curvedLine2 = (
                <StarEffect
                    scaleRange={[MIN_MULT * .1, .2 * MAX_MULT]}
                    // positionRange={rightGroupA}
                    determinedPositions={curvedLinePoints2}
                    scene={threeJSWorldContext.scene}
                    addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                    removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                    // starCount={COUNT_MULT*100}
                    randomizeColor={false}
                />
            )
            
            //heater right side vertical line
            const curvedLinePoints3 = getLinePoints2(COUNT_MULT * 12, 2, -5, -3.6, -3.6, -.425, -1.3, 0.1, 0)
            const curvedLine3 = (
                <StarEffect
                    scaleRange={[MIN_MULT * .1, .2 * MAX_MULT]}
                    // positionRange={rightGroupA}
                    determinedPositions={curvedLinePoints3}
                    scene={threeJSWorldContext.scene}
                    addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                    removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                    // starCount={COUNT_MULT*100}
                    randomizeColor={false}
                    />
                    )

            //heater right side horizontal line
            const curvedLinePoints4 = getCurvedLinePointsConstZ(COUNT_MULT * 12, -3.5, -2.4, -1.75, -5, -.35, 0)
            const curvedLine4 = (
                <StarEffect
                    scaleRange={[MIN_MULT * .1, .15 * MAX_MULT]}
                    // positionRange={rightGroupA}
                    determinedPositions={curvedLinePoints4}
                    scene={threeJSWorldContext.scene}
                    addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                    removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                    // starCount={COUNT_MULT*100}
                    randomizeColor={false}
                />
            )
            //heater right side horizontal line
            const curvedLinePoints5 = getCurvedLinePointsConstZ(COUNT_MULT * 12, 1.5, 3.1, -1.75, -5, -.6, 0)
            const curvedLine5 = (
                <StarEffect
                    scaleRange={[MIN_MULT * .1, .15 * MAX_MULT]}
                    // positionRange={rightGroupA}
                    determinedPositions={curvedLinePoints5}
                    scene={threeJSWorldContext.scene}
                    addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                    removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                    // starCount={COUNT_MULT*100}
                    randomizeColor={false}
                />
            )

            const curvedLinePoints6 = getCurvedLinePointsConstX(COUNT_MULT * 12,0,5, -2.1, -2.1,-4.17, -2.85, -.4, 0)
            const curvedLine6 = (
                <StarEffect
                    scaleRange={[MIN_MULT * .13, .2 * MAX_MULT]}
                    // positionRange={rightGroupA}
                    determinedPositions={curvedLinePoints6}
                    scene={threeJSWorldContext.scene}
                    addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                    removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                    // starCount={COUNT_MULT*100}
                    randomizeColor={false}
                />
            )
            
            const curvedLinePoints7 = getCurvedLinePointsConstX(COUNT_MULT * 12,0,5, -2.6, -2.6,3.5, 5.3, -.6, 0)
            const curvedLine7 = (
                <StarEffect
                    scaleRange={[MIN_MULT * .13, .2 * MAX_MULT]}
                    // positionRange={rightGroupA}
                    determinedPositions={curvedLinePoints7}
                    scene={threeJSWorldContext.scene}
                    addToRenderLoop={threeJSWorldContext.addToRenderLoop}
                    removeFromRenderLoop={threeJSWorldContext.removeFromRenderLoop}
                    // starCount={COUNT_MULT*100}
                    randomizeColor={false}
                />
            )
            
            return (
            <>
                {leftLine}
                {rightLine}
                {leftWindowLeftLine}
                {leftWindowRightLine}
                {/* {aboveHeaterPointsLine} */}
                {rightWindowLeftLine}
                {rightWindowRightLine}
                {leftHangingLine}
                {rightHangingLine}
                {curvedLine}
                {curvedLine2}
                {curvedLine3}
                {curvedLine4}
                {curvedLine5}
                {curvedLine6}
                {curvedLine7}
            </>
        )
    }
}